$(function () {
    let body = $('#MainContent')

    let list = [
        'template--16642416509175__606881b4-cbe2-4504-bb2d-98a935590e59',
        'template--16642416509175__0887b959-5970-456f-87c5-9cba8084c642',
        'template--16642416509175__85a1aed3-47c6-43d5-a3a6-84b025084e52'
    ]
    for (let i of list) {
        body.find(`div[data-section-id="${i}"]`).children().addClass('imgPadding')
    }

});